import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '../..';
import parseStatusCode from '../../errors/parseStatusCode';
import type { Injections } from '../../services/injections';
import type { AssetTag } from '../../services/FP_FulfillmentContextService/types';
import type { ApplicationErrorOptions } from '../../../types';

export interface TagsModel {
  tagsMap: Record<string, AssetTag>;
  setTags: Action<TagsModel, AssetTag[]>;
  setTag: Action<TagsModel, AssetTag>;
  fetchTagsLoading: boolean;
  setFetchTagsLoading: Action<TagsModel, boolean>;
  fetchTags: Thunk<TagsModel, void, Injections, StoreModel, Promise<void>>;
  fetchTagsFailure: Action<TagsModel, ApplicationErrorOptions>;
}

export const tagsModel: TagsModel = {
  tagsMap: {},
  setTags: action((state, tags) => {
    const tagsMap = tags.reduce<Record<string, AssetTag>>((acc, curr) => {
      acc[curr.tagId] = curr;
      return acc;
    }, {});
    state.tagsMap = tagsMap;
  }),
  setTag: action((state, tag) => {
    state.tagsMap[tag.tagId] = tag;
  }),
  fetchTagsLoading: false,
  setFetchTagsLoading: action((state, isLoading) => {
    state.fetchTagsLoading = isLoading;
  }),
  fetchTags: thunk(async (actions, payload, { injections, getState }) => {
    try {
      actions.setFetchTagsLoading(true);
      const { fulfillmentContextService } = injections;
      const response = await fulfillmentContextService.fetchTags();
      actions.setTags(response);
      actions.setFetchTagsLoading(false);
      return response;
    } catch (error) {
      actions.fetchTagsFailure({
        error,
        httpCode: parseStatusCode(error),
        asNotification: false,
        message: error.message || 'An error occurred, unable to fetch asset details',
      });
      actions.setFetchTagsLoading(false);
      return error;
    }
  }),
  fetchTagsFailure: action((state, error) => {
    console.error(error);
  }),
};

export default tagsModel;
